import {
  createCognitoAuthConfig,
  type SignInOptions,
} from '@consolidocs-ui/components';

export const cognitoAuthConfig = createCognitoAuthConfig({
  authority: import.meta.env.VITE_COGNITO_AUTH_AUTHORITY,
  clientId: import.meta.env.VITE_COGNITO_AUTH_CLIENT_ID,
  clientSecret: import.meta.env.VITE_COGNITO_AUTH_CLIENT_SECRET,
});

const microsoftClientId = import.meta.env.VITE_MICROSOFT_CLIENT_ID ?? '';

/**
 * What the app's own sign-in page offers besides email and password.
 *
 * Both values are tested with a pattern rather than for truthiness or with
 * `=== 'true'`: the ECS image fills in `___VITE_…___` placeholders after the
 * build, so an unset placeholder must read as "off", and a literal comparison
 * would already have been folded away by the minifier.
 */
export const signInOptions: SignInOptions = {
  // The Entra app (client) id; a GUID.
  microsoftClientId: /^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i.test(
    microsoftClientId
  )
    ? microsoftClientId
    : undefined,
  // Only where the user pool has a `Google` identity provider.
  google: /^true$/i.test(import.meta.env.VITE_GOOGLE_SIGN_IN ?? ''),
};
